import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export default class Header extends AuxiliumComponent {
	static observable = ["size", "link", "icon", "casing", "element"];

	constructor() {
		super();

		this.size ??= "1";
		this.element ??= "div";
	}

	parsedCallback() {
		const element = document.createElementWithContents(this.link ? "chip-link" : this.element, this.childNodes, {
			className: `heading--size${this.size} heading--core`
		}), actionBar = element.querySelector("chip-actionbar");

		if (this.link) { element.href = Browser.ResolveRelativeURL(this.link); }
		if (this.icon) { element.prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon })); }

		this.appendChild(element);

		if (actionBar) {
			this.appendChild(actionBar);
		}
	}

	get textContent() { return this.querySelector(".heading--core")?.textContent ?? super.textContent; }

	set textContent(value) {
		const target = this.querySelector(".heading--core");

		if (target) {
			target.textContent = value;
		}
	}

	attributeChanged(name, oldValue, newValue) {
		if (name === "size") {
			this.firstElementChild.classList.remove(`heading--size${oldValue}`);
			this.firstElementChild.classList.add(`heading--size${newValue}`);
		}
	}

	SetText(text) {
		if (this.firstElementChild) {
			this.firstElementChild.textContent = text;
		} else {
			this.textContent = text;
		}
	}
}
